import PrivateEvents from "pages/Restaurant/PrivateEvents";

export default function PrivateEventsPage() {
  return <PrivateEvents />;
}
